"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useFetch2 = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFetch"));
var _useFilter = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFilter"));
var _ProductDetailContext = _interopRequireDefault(require("../../../ProductDetail/context/ProductDetailContext"));
var _ProductSelectionContext = _interopRequireDefault(require("../../../ProductDetail/context/ProductSelectionContext"));
var _Select = _interopRequireDefault(require("./Select"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CombinationSelection = function CombinationSelection(_ref) {
  var _ref$displayedAttribu = _ref.displayedAttributes,
    displayedAttributes = _ref$displayedAttribu === void 0 ? [] : _ref$displayedAttribu,
    lang = _ref.lang;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var _useContext = (0, _react.useContext)(_ProductDetailContext.default),
    attributes = _useContext.attributes,
    combinationValues = _useContext.combinationValues,
    productDetailData = _useContext.productDetailData,
    setAttributes = _useContext.setAttributes,
    setCombinationValues = _useContext.setCombinationValues,
    setProductDetailData = _useContext.setProductDetailData;
  var _useContext2 = (0, _react.useContext)(_ProductSelectionContext.default),
    setProductSelection = _useContext2.setProductSelection;
  var _ref2 = productDetailData || {},
    combinationID = _ref2.defaultCombinationID,
    productID = _ref2.id;
  var refForm = (0, _react.useRef)(null);
  var selection = (0, _useFilter.default)(refForm, {
    combinationID: combinationID,
    productID: productID
  });
  var _useFetch = (0, _useFetch2.default)({
      data: JSON.parse(JSON.stringify(combinationValues)),
      url: "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.ProductApi/CombinationSelection.api"),
      method: "GET"
    }, [combinationValues], !(0, _isEmpty.default)(combinationValues) && (combinationValues === null || combinationValues === void 0 ? void 0 : combinationValues.productID) && (combinationValues === null || combinationValues === void 0 ? void 0 : combinationValues.combinationID)),
    _useFetch$attributes = _useFetch.attributes,
    fetchedAttributes = _useFetch$attributes === void 0 ? {} : _useFetch$attributes,
    _useFetch$combination = _useFetch.combination,
    combination = _useFetch$combination === void 0 ? {} : _useFetch$combination,
    _useFetch$_loading = _useFetch._loading,
    _loading = _useFetch$_loading === void 0 ? true : _useFetch$_loading;
  (0, _react.useEffect)(function () {
    if ((0, _isEmpty.default)(fetchedAttributes)) return;
    setAttributes(fetchedAttributes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedAttributes]);
  (0, _react.useEffect)(function () {
    var _selection$lang;
    var _combinationValues = JSON.parse(JSON.stringify(combinationValues));
    _combinationValues.combinationID = selection !== null && selection !== void 0 && selection.combinationID ? parseInt(selection.combinationID) : combinationID;
    _combinationValues.productID = selection !== null && selection !== void 0 && selection.productID ? parseInt(selection.productID) : productID;
    _combinationValues.lang = (_selection$lang = selection.lang) !== null && _selection$lang !== void 0 ? _selection$lang : lang;
    if (!(0, _isEmpty.default)(attributes)) {
      for (var _i = 0, _Object$keys = Object.keys(attributes); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        var value = selection[key];
        if (value) _combinationValues[key] = value !== null && value !== void 0 ? value : "";
      }
    }
    setCombinationValues(function (prevCombinationValues) {
      return _objectSpread(_objectSpread({}, prevCombinationValues), _combinationValues);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combinationID, productID, selection]);
  (0, _react.useEffect)(function () {
    if ((0, _isEmpty.default)(combination)) return;
    var _ref3 = combination || {},
      available = _ref3.available,
      availableCount = _ref3.availableCount,
      combinationID = _ref3.combinationID;
    setProductSelection(function (prevProductSelection) {
      return _objectSpread(_objectSpread({}, prevProductSelection), {}, {
        combinationID: combinationID,
        lang: lang,
        productID: productID
      });
    });
    setProductDetailData(function (prevProductDetailData) {
      return _objectSpread(_objectSpread(_objectSpread({}, prevProductDetailData), combination), {}, {
        available: available,
        availableCount: availableCount
      });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combination]);
  var getValue = (0, _react.useCallback)(function (options) {
    var _options$find$id, _options$find;
    return (_options$find$id = options === null || options === void 0 ? void 0 : (_options$find = options.find(function (_ref4) {
      var selected = _ref4.selected;
      return selected;
    })) === null || _options$find === void 0 ? void 0 : _options$find.id) !== null && _options$find$id !== void 0 ? _options$find$id : "";
  }, []);
  var selectionAttributes = (0, _react.useMemo)(function () {
    if ((0, _isEmpty.default)(displayedAttributes)) return Object.keys(attributes);
    var identifier = [];
    for (var attribute in attributes) {
      if (displayedAttributes.indexOf(attribute) > -1) {
        identifier.push(attribute);
      }
    }
    return identifier;
  }, [attributes, displayedAttributes]);
  if ((0, _isEmpty.default)(fetchedAttributes)) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-product-detail-combination-selection"
  }, /*#__PURE__*/_react.default.createElement("form", {
    ref: refForm
  }, combinationID && /*#__PURE__*/_react.default.createElement("input", {
    name: "combinationID",
    type: "hidden",
    value: combinationID
  }), productID && /*#__PURE__*/_react.default.createElement("input", {
    name: "productID",
    type: "hidden",
    value: productID
  }), selectionAttributes === null || selectionAttributes === void 0 ? void 0 : selectionAttributes.map(function (identifier) {
    var _ref5 = (attributes === null || attributes === void 0 ? void 0 : attributes[identifier]) || {},
      _ref5$items = _ref5.items,
      items = _ref5$items === void 0 ? [] : _ref5$items,
      title = _ref5.title;
    var value = getValue(items);
    return /*#__PURE__*/_react.default.createElement(_Select.default, {
      attributes: attributes,
      identifier: identifier,
      key: identifier,
      label: title,
      lang: lang,
      loading: _loading,
      options: items,
      value: value
    });
  })));
};
CombinationSelection.propTypes = {
  displayedAttributes: _propTypes.default.array,
  lang: _propTypes.default.string
};
var _default = CombinationSelection;
exports.default = _default;